/* rk-cart: custom cart drawer, replaces the UpCart app.
   Intercepts the same entry points UpCart did, so pages need no changes:
   - clicks on links to /cart (header icon, CTAs)
   - fetch() calls to /cart/add|change|update|clear (rk-atc, product-form, rk- scripts)
   - <form action="/cart/add"> submits nobody else handled
   - the upcart:open / upcart:refresh / cart:refresh events rk- scripts already dispatch
   Compat aliases: window.upcartOpenCart, window.upcartRefreshCart, window.UpCart.
   Internal requests carry ?rkcart=1 so they are never intercepted. */
(function () {
  if (window.RkCart) return;

  var root = document.getElementById('rk-cart');
  var cfgEl = document.getElementById('rk-cart-config');
  if (!root) return;

  /* No config (the 'Cart drawer' section was hidden/deleted) or bad JSON: run with defaults and say so,
     so add-to-cart still opens the drawer instead of silently doing nothing. */
  var cfg = {};
  if (!cfgEl) { if (window.console) console.error('rk-cart: config section missing, using defaults (add the "Cart drawer" section back in the theme editor)'); }
  else { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { if (window.console) console.error('rk-cart: config JSON is invalid, using defaults', e); cfg = {}; } }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  cfg.groups = cfg.groups || [];
  cfg.recommendations = cfg.recommendations || [];
  cfg.cartUrl = cfg.cartUrl || ROOT + 'cart';
  cfg.shopUrl = cfg.shopUrl || ROOT + 'collections/all';
  cfg.freeShippingCents = Number(cfg.freeShippingCents) > 0 ? Number(cfg.freeShippingCents) : 0;

  var body = root.querySelector('[data-rk-body]');
  var footer = root.querySelector('[data-rk-footer]');
  var panel = root.querySelector('.rk-cart__panel');
  var CART_RE = /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?cart\/?$/i;
  var API_RE = /\/cart\/(add|change|update|clear)(\.js)?$/i;
  var cart = null;
  var isOpen = false;
  var busy = false;
  var lastFocus = null;
  var inflight = null;
  var products = {};
  var productData = {};
  var pending = {};
  var timers = {};
  var staleCartPage = false; /* the drawer changed the cart while the /cart page was showing it */

  var EARLY = window.__rkCartEarly || null;
  /* Wrap whatever window.fetch is right now (it may already carry Shopify's web pixels hook, which fires
     product_added_to_cart). The early stub's saved copy would skip that hook. The stub's own wrapper is a
     pass-through once window.RkCart exists, so it stays in the chain; it only keeps its queue. */
  var nativeFetch = window.fetch.bind(window);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Price format: learned from the store's own `money` filter (server renders a probe amount, 1,234,567.89),
     so the drawer shows prices exactly like the product page (decimal/thousands separators, symbol, position). */
  var fmt = (function () {
    var t = String(cfg.moneyProbe || '').replace(/<[^>]*>/g, '');
    try { var ta = document.createElement('textarea'); ta.innerHTML = t; t = ta.value; } catch (err) { t = t.replace(/&nbsp;/g, ' '); }
    t = t.trim();
    var m = /\d[\d.,  ' ]*\d/.exec(t);
    if (!m) return null;
    var num = m[0];
    var dm = /([.,])(\d{2})$/.exec(num);
    var intPart = dm ? num.slice(0, dm.index) : num;
    var ts = /[^\d]/.exec(intPart);
    return { pre: t.slice(0, m.index), suf: t.slice(m.index + num.length), dsep: dm ? dm[1] : '', dec: dm ? 2 : 0, tsep: ts ? ts[0] : '' };
  })();

  function money(cents) {
    if (fmt) {
      var parts = (Math.abs(cents) / 100).toFixed(fmt.dec).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.tsep);
      return (cents < 0 ? '-' : '') + fmt.pre + whole + (fmt.dec ? fmt.dsep + parts[1] : '') + fmt.suf;
    }
    var cur = (cart && cart.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function img(src, w) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return src; }
  }

  /* Same copy and rules as UpCart: the store's own message only for a 422, otherwise a generic line. */
  var I18N = cfg.i18n || {};
  var DEFAULT_ERR = I18N.errorAdd || "Couldn't add this item to your cart. Please try again.";
  var NET_ERR = DEFAULT_ERR;
  var UPDATE_ERR = I18N.errorUpdate || "Couldn't update your cart. Please try again.";
  function L(k, d) { return I18N[k] || d; }
  var STOCK_ERR = I18N.errorStock || "Sorry, we don't have enough of this item in stock to add more.";
  var STOCK_RE = /sold out|only add|only \d+|availability|already|in your cart|out of stock|not enough|stock/i;
  var toastEl = null;
  var toastTimer = null;

  /* Visible, announced error message (top of the screen, above the drawer). */
  function showError(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rk-cart__toast';
      toastEl.setAttribute('role', 'alert');
      toastEl.innerHTML = '<div class="rk-cart__toast-box upcart-quantity-warning"><span class="rk-cart__toast-msg upcart-quantity-warning-text"></span></div>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.rk-cart__toast-msg').textContent = msg || DEFAULT_ERR;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideError, 3000);
  }

  /* ---------- rk:atc: add-to-cart event for GTM / custom tracking ----------
     dataLayer.push({event:'rk:atc', variantId, qty, price (unit, major units), currency, ...}) and a
     document CustomEvent 'rk:atc' with the same payload in detail. One event per added line. */
  var lastAtc = { id: '', t: 0 };
  /* id of the button that started the request, read when the request is made (not when it answers) */
  function srcNow() { return Date.now() - lastAtc.t < 4000 ? lastAtc.id : ''; }

  function emitAtc(items, source, qtys, btnId) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || (cart && cart.currency) || '';
    window.dataLayer = window.dataLayer || [];
    items.forEach(function (it, idx) {
      if (!it || !it.variant_id) return;
      var d = {
        variantId: it.variant_id,
        qty: (qtys && qtys[idx] > 0) ? qtys[idx] : it.quantity,
        price: (it.final_price != null ? it.final_price : it.price) / 100,
        currency: cur,
        productId: it.product_id,
        productTitle: it.product_title,
        handle: it.handle,
        buttonId: source === 'upsell' ? 'rk-atc-upsell-' + (it.handle || it.variant_id) : (btnId || ''),
        source: source || 'page'
      };
      var ev = { event: 'rk:atc' };
      Object.keys(d).forEach(function (k) { ev[k] = d[k]; });
      window.dataLayer.push(ev);
      document.dispatchEvent(new CustomEvent('rk:atc', { detail: d }));
      publish('rk:atc', d);
    });
  }

  /* Shopify's analytics channel: a Customer events (web pixel) sandbox, e.g. the GTM container, can only hear events published here. */
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) { /* tracking must never break the cart */ }
  }

  /* upsell_view (tile >= 50% visible in the open drawer, once per tile per opening) and upsell_accept (its Add clicked).
     upsell_name = product handle, same as the GemPages-era GTM tag. dataLayer + CustomEvent + analytics channel like rk:atc. */
  var upsellSeen = {}, upsellIO = null;
  function emitUpsell(kind, handle) {
    if (!handle) return;
    var d = { upsell_name: handle };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: kind, upsell_name: handle });
    document.dispatchEvent(new CustomEvent('rk:' + kind, { detail: d }));
    publish('rk:' + kind, d);
  }
  function watchUpsells() {
    if (upsellIO) { upsellIO.disconnect(); upsellIO = null; }
    if (!isOpen || !('IntersectionObserver' in window)) return;
    upsellIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var h = en.target.getAttribute('data-upcart-upsell');
        if (!en.isIntersecting || !h || upsellSeen[h]) return;
        upsellSeen[h] = 1;
        emitUpsell('upsell_view', h);
      });
    }, { threshold: 0.5 });
    var tiles = root.querySelectorAll('[data-upcart-upsell]');
    for (var i = 0; i < tiles.length; i++) upsellIO.observe(tiles[i]);
  }

  function emitFromResponse(j, source, qtys, btnId) {
    emitAtc(j && j.items ? j.items : [j], source, qtys, btnId);
  }

  /* Quantities the page asked for (the response carries the line total, not what was added).
     Shopify returns items in request order. */
  function requestedQtys(init) {
    var b = init && init.body;
    var q = function (v) { v = parseInt(v, 10); return v > 0 ? v : 1; };
    try {
      if (!b) return null;
      if (typeof b === 'string') {
        if (b.charAt(0) === '{') {
          var o = JSON.parse(b);
          if (o.items && o.items.length) return o.items.map(function (i) { return q(i.quantity); });
          return [q(o.quantity)];
        }
        b = new URLSearchParams(b);
      }
      if (typeof b.get === 'function') return [q(b.get('quantity'))];
    } catch (err) {}
    return null;
  }

  /* Fixed, unique ids on every add-to-cart button (GTM "Click ID"). The main/sticky/steps buttons have ids in
     the Liquid; the rest get rk-atc-cta-<section key> (+ -2, -3 when a section has several), so moving a section
     does not change them. Buttons outside a section: rk-atc-cta-1, ... by position. */
  function tagAtcButtons() {
    var used = {};
    [].forEach.call(document.querySelectorAll('[id^="rk-atc-"]'), function (e) { used[e.id] = 1; });
    var list = document.querySelectorAll('[data-rk-atc], rk-atc button[type="submit"], rk-lw-atc button[type="submit"], rk-lmb-atc button[type="submit"], rk-ltb-atc button[type="submit"], rk-lcb-atc button[type="submit"]');
    var n = 0;
    [].forEach.call(list, function (b) {
      if (b.id) return;
      var id;
      var sec = b.closest('[id^="shopify-section-"]');
      var key = sec ? sec.id.replace(/^shopify-section-/, '').replace(/^template--\d+__/, '').replace(/[^a-z0-9_-]/gi, '-') : '';
      if (!used['rk-atc-main']) id = 'rk-atc-main';
      else if (key) { var k = 1; id = 'rk-atc-cta-' + key; while (used[id]) { k++; id = 'rk-atc-cta-' + key + '-' + k; } }
      else { do { n++; id = 'rk-atc-cta-' + n; } while (used[id]); }
      b.id = id;
      used[id] = 1;
    });
  }

  function hideError() {
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function errMsg(j, status) {
    if (status !== 422) return '';
    /* stock / quantity-limit texts get our own copy; anything else ("Cannot find variant"...) the generic message */
    var t = (j && (j.description || j.message)) || '';
    return STOCK_RE.test(t) ? STOCK_ERR : '';
  }

  /* store-relative URL: respects a market/locale prefix such as /en-gb/ (Shopify.routes.root) */
  function rooted(path) { return ROOT !== '/' && path.charAt(0) === '/' && path.indexOf(ROOT) !== 0 ? ROOT.replace(/\/$/, '') + path : path; }
  function api(path, opts) {
    path = rooted(path);
    var sep = path.indexOf('?') > -1 ? '&' : '?';
    return window.fetch(path + sep + 'rkcart=1', opts).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          var e = new Error(path + ' ' + r.status);
          e.rkMessage = errMsg(j, r.status);
          throw e;
        });
      }
      if (API_RE.test(path.split('?')[0])) staleCartPage = true;
      return r.json();
    }, function (e) {
      e.rkMessage = NET_ERR;
      throw e;
    });
  }

  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = nativeFetch(rooted('/products/' + encodeURIComponent(handle) + '.js?rkcart=1'))
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) { productData[handle] = p; return p; });
    }
    return products[handle];
  }

  /* ---------- data ---------- */

  /* Every call fetches a fresh /cart.js; a response that is no longer the latest request is discarded
     (a preload started before an add must not paint a cart without the new product). */
  var seq = 0;
  var painted = false; /* the drawer shows the current cart (warm-up fetches the cart only; products load on open) */
  var latest = null;
  function refresh() {
    var my = ++seq;
    var p = api('/cart.js').then(function (c) {
      if (my !== seq) return latest;
      cart = c;
      return render().then(function () { painted = true; return c; });
    });
    inflight = latest = p;
    var done = function () { if (inflight === p) inflight = null; };
    p.then(done, done);
    return p;
  }

  var chain = Promise.resolve();
  var queued = 0; /* changes sent to the chain but not finished (busy only flips once one starts) */
  function change(key, qty) {
    queued++;
    chain = chain.then(function () { return doChange(key, qty); }).then(function () { queued--; }, function () { queued--; });
  }

  function doChange(key, qty) {
    busy = true;
    root.classList.add('is-busy');
    return api('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (c) { seq++; cart = c; return render(); })
      .catch(function (e) {
        showError(e.rkMessage || UPDATE_ERR);
        return refresh().catch(function () {});
      })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  /* +/- clicks: accumulate locally, send one change after a short pause so rapid clicks are not dropped */
  function stepQty(key, delta) {
    var line = cart && cart.items.filter(function (i) { return i.key === key; })[0];
    if (!line) return;
    var base = pending[key] != null ? pending[key] : line.quantity;
    var next = Math.max(0, base + delta);
    pending[key] = next;
    var input = panel.querySelector('[data-rk-qty="' + key + '"]');
    if (input) input.value = next;
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { delete pending[key]; change(key, next); }, next === 0 ? 0 : 300);
  }

  /* Send every waiting +/- change now; resolves when all cart changes have finished. */
  function flushPending() {
    Object.keys(pending).forEach(function (key) {
      clearTimeout(timers[key]);
      var q = pending[key];
      delete pending[key];
      change(key, q);
    });
    return chain;
  }

  /* Secure checkout: never leave with a quantity change still waiting or in flight. */
  var checkoutOk = false;
  root.addEventListener('submit', function (e) {
    if (checkoutOk) return;
    if (!Object.keys(pending).length && !busy && !queued) return;
    e.preventDefault();
    var form = e.target;
    flushPending().then(function () {
      /* the footer re-rendered while the changes finished: the tapped form is detached, submit the live one */
      var live = root.querySelector('[data-rk-footer] form') || (form.isConnected ? form : null);
      if (!live) { location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'checkout'; return; }
      checkoutOk = true;
      try { live.requestSubmit(live.querySelector('[name="checkout"]')); } catch (err) { live.submit(); }
      checkoutOk = false;
    });
  }, true);

  function addUpsell(btn) {
    if (btn.disabled) return;
    var utile = btn.closest('[data-upcart-upsell]');
    if (utile) emitUpsell('upsell_accept', utile.getAttribute('data-upcart-upsell'));
    btn.disabled = true;
    var label = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span class="rk-cart__spin" role="status" aria-label="Adding to cart"></span>';
    var item = { id: Number(btn.getAttribute('data-variant')), quantity: 1 };
    api('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (j) {
      /* the add worked: a failing refresh must not look like a failed add (the customer would retry and get 2) */
      emitFromResponse(j, 'upsell', [1]);
      return refresh().catch(function () {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.innerHTML = 'Added';
      });
    }, function (e) {
      btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.innerHTML = label;
      showError(e.rkMessage || DEFAULT_ERR);
    });
  }

  /* ---------- render ---------- */

  function rewardsHtml() {
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var goal = Math.round(cfg.freeShippingCents * rate);
    if (!(goal > 0)) return ''; /* no threshold configured: no bar */
    /* what Shopify compares to the free rate: shippable items (no gift cards / digital) after order-level discounts */
    var sub = 0;
    if (cart) {
      cart.items.forEach(function (i) { if (i.requires_shipping && !i.gift_card) sub += i.final_line_price; });
      sub -= (cart.cart_level_discount_applications || []).reduce(function (n, d) { return n + (d.total_allocated_amount || 0); }, 0);
      sub = Math.max(0, sub);
      if (!cart.requires_shipping) return '';
    }
    var left = Math.max(0, goal - sub);
    var pct = Math.min(100, Math.round((sub / goal) * 100));
    var msg = left > 0
      ? L('shippingAway', 'You are <strong>__AMOUNT__</strong> away from <strong>FREE SHIPPING</strong>').replace('__AMOUNT__', esc(money(left)))
      : L('shippingUnlocked', '<strong>Congrats!</strong> You\'ve unlocked <strong>FREE SHIPPING!</strong>');
    return '<div class="rk-cart__rewards"><p>' + msg + '</p>' +
      '<div class="rk-cart__bar" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
      '<span style="width:' + pct + '%"></span></div></div>';
  }

  function propsHtml(item) {
    var out = [];
    if (item.variant_title && item.product_has_only_default_variant === false) out.push(esc(item.variant_title));
    var p = item.properties || {};
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' || p[k] === '' || p[k] == null) return;
      out.push(esc(k) + ': ' + esc(p[k]));
    });
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) out.push(esc(item.selling_plan_allocation.selling_plan.name));
    return out.length ? '<p class="rk-cart__meta">' + out.join('<br>') + '</p>' : '';
  }

  function itemHtml(item, prod) {
    var compare = 0;
    if (prod) {
      var v = prod.variants.filter(function (x) { return x.id === item.variant_id; })[0];
      if (v && v.compare_at_price && v.compare_at_price > item.final_price) compare = v.compare_at_price * item.quantity;
    }
    if (!compare && item.original_line_price > item.final_line_price) compare = item.original_line_price;
    var k = esc(item.key);
    return '<li class="rk-cart__item upcart-public-component-product-tile" data-key="' + k + '">' +
      '<a class="rk-cart__img" href="' + esc(item.url) + '" aria-label="' + esc(item.product_title) + '" tabindex="-1">' +
      (item.image ? '<img src="' + esc(img(item.image, 176)) + '" alt="' + esc(item.featured_image && item.featured_image.alt || item.product_title) + '" width="88" height="88" loading="lazy">' : '') + '</a>' +
      '<div class="rk-cart__info">' +
      '<div class="rk-cart__row"><a class="rk-cart__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
      '<button type="button" class="rk-cart__remove" data-rk-remove="' + k + '" aria-label="Remove ' + esc(item.product_title) + '">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v5M14 11v5"/></svg></button></div>' +
      propsHtml(item) +
      priceHtml(item.final_line_price, compare) +
      '<div class="rk-cart__qty"><button type="button" data-rk-minus="' + k + '" aria-label="Decrease quantity of ' + esc(item.product_title) + '">&minus;</button>' +
      '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + item.quantity + '" data-rk-qty="' + k + '" aria-label="Quantity of ' + esc(item.product_title) + '">' +
      '<button type="button" data-rk-plus="' + k + '" aria-label="Increase quantity of ' + esc(item.product_title) + '">+</button></div>' +
      '</div></li>';
  }

  function tileHtml(entry, prod, isUpsell) {
    var ids = entry.v == null ? null : [].concat(entry.v).map(String);
    if (ids && !ids.length) ids = null; /* handle only: no variants listed */
    var variants = ids ? prod.variants.filter(function (x) { return ids.indexOf(String(x.id)) > -1; }) : [];
    /* no variants listed, or the listed ones no longer exist: offer the product's first available variant */
    if (!variants.length) {
      if (ids && window.console) console.warn('rk-cart: configured variant(s) of "' + entry.h + '" no longer exist, using the first available variant');
      var first = prod.variants.filter(function (x) { return x.available !== false; })[0] || prod.variants[0];
      variants = first ? [first] : [];
    }
    if (!variants.length) return '';
    var v = variants.filter(function (x) { return x.available !== false; })[0] || variants[0];
    if (!v) return '';
    var photo = (prod.featured_image || (prod.images && prod.images[0]) || '');
    var sel = '';
    if (variants.length > 1) {
      sel = '<select class="rk-cart__select" data-rk-variant aria-label="Option for ' + esc(prod.title) + '">' + variants.map(function (x) {
        return '<option value="' + x.id + '" data-price="' + x.price + '" data-compare="' + (x.compare_at_price || 0) + '"' +
          (x.id === v.id ? ' selected' : '') + (x.available === false ? ' disabled' : '') + '>' + esc(x.title) + '</option>';
      }).join('') + '</select>';
    }
    return '<li class="rk-cart__tile upcart-public-component-product-tile"' + (isUpsell ? ' data-upcart-upsell="' + esc(prod.handle) + '"' : '') + '>' +
      '<a class="rk-cart__img" href="' + esc(rooted('/products/' + prod.handle)) + '" aria-label="' + esc(prod.title) + '" tabindex="-1">' + (photo ? '<img src="' + esc(img(photo, 176)) + '" alt="" width="88" height="88" loading="lazy">' : '') + '</a>' +
      '<div class="rk-cart__info upcart-public-component-product-tile__info"><a class="rk-cart__title upcart-public-component-product-tile__header" href="' + esc(rooted('/products/' + prod.handle)) + '">' + esc(prod.title) + '</a>' +
      priceHtml(v.price, v.compare_at_price) +
      '<div class="rk-cart__actions' + (sel ? ' rk-cart__actions--sel' : '') + '">' + sel +
      '<button type="button" id="rk-atc-' + (isUpsell ? 'upsell' : 'rec') + '-' + esc(prod.handle) + '" class="rk-cart__btn" data-rk-add data-upsell="' + (isUpsell ? 1 : 0) + '" data-variant="' + v.id + '" data-product="' + prod.id + '" aria-label="Add ' + esc(prod.title) + ' to cart"' +
      (v.available === false ? ' disabled' : '') + '>' + (v.available === false ? L('soldOut', 'Sold out') : L('add', 'Add +')) + '</button></div></div></li>';
  }

  function priceHtml(price, compare) {
    compare = compare && compare > price ? compare : 0;
    return '<p class="rk-cart__price">' + (compare ? '<s>' + esc(money(compare)) + '</s>' : '') + '<span>' + esc(money(price)) + '</span></p>';
  }

  function carousel(title, entries, isUpsell, cls) {
    return Promise.resolve(entries.map(function (e) { return productData[e.h]; })).then(function (list) {
      var tiles = list.map(function (p, i) { return p ? tileHtml(entries[i], p, isUpsell) : ''; }).join('');
      if (!tiles) return '';
      if (cls === 'recs') return '<section class="rk-cart__recs"><h3>' + esc(title) + '</h3><ul class="rk-cart__list">' + tiles + '</ul></section>';
      return '<section class="rk-cart__' + cls + '"><h3>' + esc(title) + '</h3>' +
        '<div class="rk-cart__carousel"><button type="button" class="rk-cart__nav" data-rk-nav="-1" aria-label="Previous">&lsaquo;</button>' +
        '<div class="rk-cart__swiper"><ul class="rk-cart__track">' + tiles + '</ul></div>' +
        '<button type="button" class="rk-cart__nav" data-rk-nav="1" aria-label="Next">&rsaquo;</button></div></section>';
    });
  }

  /* Mute the arrow at either end of the carousel (and both when everything fits). */
  function setNav(wrap, atStart, atEnd) {
    var prev = wrap.querySelector('[data-rk-nav="-1"]');
    var next = wrap.querySelector('[data-rk-nav="1"]');
    if (prev) { prev.classList.toggle('is-muted', atStart); prev.setAttribute('aria-disabled', atStart ? 'true' : 'false'); }
    if (next) { next.classList.toggle('is-muted', atEnd); next.setAttribute('aria-disabled', atEnd ? 'true' : 'false'); }
  }

  /* Upsell carousel: Swiper (assets/rk-swiper.min.js), loaded the first time a carousel is painted.
     One tile per view, same markup and arrows as before; until it loads the first tile just shows. */
  var swipers = [], swiperLoading = null;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (!swiperLoading) {
      swiperLoading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = cfg.swiperSrc;
        s.onload = resolve;
        s.onerror = function () { swiperLoading = null; reject(); };
        document.head.appendChild(s);
      });
    }
    return swiperLoading;
  }

  function initSwipers() {
    swipers.forEach(function (s) { s.destroy(true, false); });
    swipers = [];
    var els = root.querySelectorAll('.rk-cart__swiper');
    if (!els.length) return;
    for (var i = 0; i < els.length; i++) {
      var n = els[i].querySelectorAll('.rk-cart__tile').length;
      setNav(els[i].parentNode, true, n < 2);
    }
    loadSwiper().then(function () {
      for (var j = 0; j < els.length; j++) {
        if (!els[j].isConnected || els[j].swiper) continue;
        (function (el) {
          var sw = new window.Swiper(el, {
            wrapperClass: 'rk-cart__track',
            slideClass: 'rk-cart__tile',
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 250,
            noSwipingSelector: 'select, input'
          });
          var sync = function () { setNav(el.parentNode, sw.isBeginning, sw.isEnd); };
          sw.on('slideChange', sync);
          sw.on('resize', sync);
          sw.on('update', sync);
          sync();
          swipers.push(sw);
        })(els[j]);
      }
    }).catch(function () {});
  }

  function upsellEntries() {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.handle] = 1; });
    var seen = {}, out = [];
    cfg.groups.forEach(function (g) {
      if (!g.t.some(function (h) { return inCart[h]; })) return;
      g.o.forEach(function (o) { if (!seen[o.h] && !inCart[o.h]) { seen[o.h] = 1; out.push(o); } });
    });
    return out.slice(0, cfg.maxUpsells || 5);
  }

  function render() {
    var c = cart;
    var handles = c.items.map(function (i) { return i.handle; });
    var extra = c.items.length ? upsellEntries() : cfg.recommendations;
    extra.forEach(function (e) { handles.push(e.h); });
    var allCached = handles.every(function (h) { return h in productData; });
    var first = paint(c);
    if (allCached) return first;
    return first.then(function () {
      return Promise.all(handles.map(getProduct));
    }).then(function () { if (cart === c) return paint(c); });
  }

  function paint(c) {
    var hadFocus = panel.contains(document.activeElement);
    var focus = document.activeElement && panel.contains(document.activeElement)
      ? (document.activeElement.getAttribute('data-rk-minus') ? ['data-rk-minus', document.activeElement.getAttribute('data-rk-minus')]
        : document.activeElement.getAttribute('data-rk-plus') ? ['data-rk-plus', document.activeElement.getAttribute('data-rk-plus')]
          : null) : null;
    var empty = !c.items.length;

    var work = empty
      ? carousel('Recommended best sellers', cfg.recommendations, false, 'recs')
      : Promise.resolve({
        items: c.items.map(function (i) { return itemHtml(i, productData[i.handle]); }).join(''),
        upsell: ''
      }).then(function (r) {
        return carousel(cfg.upsellTitle, upsellEntries(), true, 'upsell').then(function (up) { r.upsell = up; return r; });
      });

    return work.then(function (res) {
      if (empty) {
        body.innerHTML = rewardsHtml() +
          '<div class="rk-cart__empty"><h2 class="rk-cart__empty-title">' + esc(L('emptyTitle', 'Your cart is empty')) + '</h2><p>' + esc(L('emptyText', 'Add your favourite items to your cart.')) + '</p>' +
          '<a class="rk-cart__btn rk-cart__btn--lg" href="' + esc(cfg.shopUrl) + '">' + esc(L('startShopping', 'Start shopping')) + '</a></div>' + res;
        footer.innerHTML = '';
      } else {
        body.innerHTML = rewardsHtml() + '<ul class="rk-cart__items">' + res.items + '</ul>' + res.upsell;
        /* Subtotal already has product discounts applied (they show struck through on the line); only order-level
           discounts get their own row, followed by the total. */
        var orderDisc = (c.cart_level_discount_applications || []).reduce(function (n, d) { return n + (d.total_allocated_amount || 0); }, 0);
        var disc = orderDisc > 0 ? '<div class="rk-cart__sub rk-cart__sub--disc"><span>' + esc(L('discounts', 'Discounts')) + '</span><span>&minus;' + esc(money(orderDisc)) + '</span></div>' : '';
        var total = orderDisc > 0 ? '<div class="rk-cart__sub rk-cart__sub--total"><span>' + esc(L('total', 'Total')) + '</span><span>' + esc(money(c.total_price)) + '</span></div>' : '';
        footer.innerHTML = '<div class="rk-cart__sub"><span>' + esc(L('subtotal', 'Subtotal')) + '</span><span>' + esc(money(c.items_subtotal_price)) + '</span></div>' + disc + total +
          '<form action="' + esc(cfg.cartUrl) + '" method="post"><button type="submit" name="checkout" class="rk-cart__btn rk-cart__btn--lg rk-cart__checkout">' +
          '<img class="rk-cart__lock" src="' + esc(cfg.lockIcon) + '" alt="" width="13" height="15"> ' + esc(L('checkout', 'Secure checkout')) + '</button></form>' +
          (cfg.trustBadge ? '<img class="rk-cart__badge" src="' + esc(cfg.trustBadge) + '" alt="Accepted payment methods" loading="lazy">' : '');
      }
      updateBubble(c.item_count);
      initSwipers();
      watchUpsells();
      var st = root.querySelector('[data-rk-status]');
      if (st) st.textContent = c.item_count ? 'Cart updated. ' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in your cart.' : 'Your cart is empty.';
      var again = focus && panel.querySelector('[' + focus[0] + '="' + focus[1] + '"]');
      if (again) again.focus();
      else if (hadFocus && isOpen) panel.focus({ preventScroll: true });
    });
  }

  function updateBubble(count) {
    var icons = document.querySelectorAll('#cart-icon-bubble');
    for (var i = 0; i < icons.length; i++) {
      var b = icons[i].querySelector('.cart-count-bubble');
      if (!count) { if (b) b.remove(); continue; }
      if (!b) {
        b = document.createElement('div');
        b.className = 'cart-count-bubble';
        b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        icons[i].appendChild(b);
      }
      var vis = b.querySelector('[aria-hidden="true"]');
      if (vis) vis.textContent = count < 100 ? count : '';
      var sr = b.querySelector('.visually-hidden');
      if (sr) sr.textContent = count + (count === 1 ? ' item' : ' items');
    }
    var extra = document.querySelectorAll('[data-cart-count]');
    for (var j = 0; j < extra.length; j++) extra[j].textContent = count;
  }

  /* ---------- open / close ---------- */

  /* Loading skeleton that mirrors the real layout: rewards, one item, upsell tile, footer. */
  function skeleton() {
    return '<div class="rk-cart__skel" aria-hidden="true">' +
      '<div class="rk-cart__skel-rewards"><s class="sk" style="width:62%"></s><s class="sk sk-bar"></s></div>' +
      '<div class="rk-cart__skel-item"><s class="sk sk-img"></s><div>' +
      '<s class="sk" style="width:70%;height:16px"></s><s class="sk" style="width:38%"></s><s class="sk" style="width:46%;height:16px"></s><s class="sk sk-qty"></s></div></div>' +
      '<div class="rk-cart__skel-up"><s class="sk sk-title"></s><div class="rk-cart__skel-item"><s class="sk sk-img"></s><div>' +
      '<s class="sk" style="width:60%;height:16px"></s><s class="sk" style="width:44%;height:16px"></s>' +
      '<div class="rk-cart__skel-row"><s class="sk sk-select"></s><s class="sk sk-add"></s></div></div></div></div></div>';
  }

  function skeletonFooter() {
    return '<div class="rk-cart__skel" aria-hidden="true"><div class="rk-cart__skel-sub"><s class="sk" style="width:90px;height:18px"></s><s class="sk" style="width:80px;height:18px"></s></div>' +
      '<s class="sk sk-btn"></s><s class="sk sk-badge"></s></div>';
  }

  function open() {
    if (isOpen) return Promise.resolve();
    isOpen = true;
    lastFocus = document.activeElement;
    root.removeAttribute('inert');
    root.classList.add('is-open');
    document.documentElement.classList.add('rk-cart-lock');
    panel.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('rkcart:open'));
    if (cart && painted) { watchUpsells(); return Promise.resolve(); }
    body.innerHTML = skeleton();
    footer.innerHTML = skeletonFooter();
    return refresh().catch(function () {
      footer.innerHTML = '';
      body.innerHTML = '<div class="rk-cart__empty"><p>' + esc(L('loadError', 'We could not load your cart.')) + '</p><a class="rk-cart__btn rk-cart__btn--lg" href="' + esc(cfg.cartUrl) + '">' + esc(L('viewCart', 'View cart')) + '</a></div>';
    });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('inert', '');
    document.documentElement.classList.remove('rk-cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('rkcart:close'));
    upsellSeen = {};
    if (upsellIO) { upsellIO.disconnect(); upsellIO = null; }
    /* /cart renders its lines server-side and identifies them by position: re-sync after drawer edits */
    if (staleCartPage && CART_RE.test(location.pathname)) location.reload();
  }

  function openAndRefresh() {
    open();
    return refresh().catch(function () {});
  }

  /* Opening because something was just added: show the skeleton, not the previous cart, until the fresh /cart.js paints. */
  function openAfterAdd() {
    var wasOpen = isOpen;
    open();
    if (!wasOpen) { body.innerHTML = skeleton(); footer.innerHTML = skeletonFooter(); }
    return refresh().catch(function () {
      if (!wasOpen) { footer.innerHTML = ''; body.innerHTML = '<div class="rk-cart__empty"><p>' + esc(L('loadError', 'We could not load your cart.')) + '</p><a class="rk-cart__btn rk-cart__btn--lg" href="' + esc(cfg.cartUrl) + '">' + esc(L('viewCart', 'View cart')) + '</a></div>'; }
    });
  }

  /* ---------- drawer UI events ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rk-close],[data-rk-remove],[data-rk-minus],[data-rk-plus],[data-rk-add],[data-rk-nav]');
    if (!t) return;
    if (t.hasAttribute('data-rk-close')) return close();
    if (t.hasAttribute('data-rk-add')) return addUpsell(t);
    if (t.hasAttribute('data-rk-nav')) {
      var holder = t.parentNode.querySelector('.rk-cart__swiper');
      var sw = holder && holder.swiper;
      if (sw) { if (Number(t.getAttribute('data-rk-nav')) > 0) sw.slideNext(); else sw.slidePrev(); }
      return;
    }
    var key = t.getAttribute('data-rk-remove') || t.getAttribute('data-rk-minus') || t.getAttribute('data-rk-plus');
    var line = cart && cart.items.filter(function (i) { return i.key === key; })[0];
    if (!line) return;
    if (t.hasAttribute('data-rk-remove')) change(key, 0);
    else stepQty(key, t.hasAttribute('data-rk-plus') ? 1 : -1);
  });

  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-rk-variant]');
    if (sel) {
      var tile = sel.closest('.rk-cart__tile');
      var opt = sel.options[sel.selectedIndex];
      tile.querySelector('.rk-cart__price').outerHTML = priceHtml(Number(opt.getAttribute('data-price')), Number(opt.getAttribute('data-compare')));
      tile.querySelector('[data-rk-add]').setAttribute('data-variant', sel.value);
      return;
    }
    var t = e.target.closest('[data-rk-qty]');
    if (!t) return;
    var n = parseInt(t.value, 10);
    var key = t.getAttribute('data-rk-qty');
    if (isNaN(n) || n < 0) return refresh();
    change(key, n);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); return close(); }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- interception (what UpCart did) ---------- */

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download') || root.contains(a)) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !CART_RE.test(u.pathname)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openAndRefresh();
  }, true);

  function wantsJs(init) {
    var h = init && init.headers;
    var a = h && (typeof h.get === 'function' ? h.get('Accept') : (h.Accept || h.accept));
    return !!a && /javascript/i.test(a);
  }

  /* True when the form that sent this request can show its own inline error (product page); card quick-add can't */
  function formHasErrorBox(init) {
    var b = init && init.body;
    try {
      if (!b || typeof b.get !== 'function') return true;
      var id = String(b.get('id'));
      var inputs = document.querySelectorAll('product-form input[name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === id && inputs[i].closest('product-form').querySelector('.product-form__error-message-wrapper')) return true;
      }
      return false;
    } catch (err) { return true; }
  }

  /* Typed quantities are not trusted: every JSON add sent by a page script goes out as an integer 1-99. */
  function clampQty(v) { v = parseInt(v, 10); return v >= 1 ? Math.min(v, 99) : 1; }
  function clampAddBody(init) {
    try {
      if (!init || typeof init.body !== 'string' || init.body.charAt(0) !== '{') return init;
      var j = JSON.parse(init.body), hit = false;
      if (j.quantity !== undefined) { j.quantity = clampQty(j.quantity); hit = true; }
      if (j.items && j.items.length) j.items.forEach(function (it) { if (it && it.quantity !== undefined) { it.quantity = clampQty(it.quantity); hit = true; } });
      if (!hit) return init;
      var c = {}; for (var k in init) c[k] = init[k];
      c.body = JSON.stringify(j);
      return c;
    } catch (err) { return init; }
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    try { if (url && /\/cart\/add(\.js)?(\?|$)/i.test(new URL(url, location.href).pathname + (url.indexOf('?') > -1 ? '?' : ''))) init = clampAddBody(init); } catch (err) {}
    var p = nativeFetch(input, init);
    if (!url || url.indexOf('rkcart=1') > -1) return p;
    var m;
    try { m = API_RE.exec(new URL(url, location.href).pathname); } catch (err) { return p; }
    if (!m) return p;
    var isAdd = m[1].toLowerCase() === 'add';
    var quiet = url.indexOf('opens_cart=never') > -1;
    /* the stock Refresh product-form (Accept: application/javascript) renders its own inline error */
    var own = wantsJs(init) && formHasErrorBox(init);
    var qtys = isAdd ? requestedQtys(init) : null;
    var src = srcNow();
    p.then(function (res) {
      if (!res) return;
      res.clone().json().then(function (j) { outcome(isAdd, quiet, own, qtys, res.ok, res.status, j, src); },
        function () { outcome(isAdd, quiet, own, qtys, res.ok, res.status, null, src); });
    }, function () {
      outcome(isAdd, quiet, own, qtys, false, 0, null, src);
    });
    return p;
  };

  /* result of a /cart/add|change|update|clear request made by the page */
  function outcome(isAdd, quiet, own, qtys, ok, status, j, btnId) {
    if (ok) {
      if (isAdd && j) emitFromResponse(j, '', qtys, btnId);
      if (isAdd && !quiet) openAfterAdd();
      else refresh().catch(function () {});
      return;
    }
    if (isAdd && !own) showError(status ? (errMsg(j, status) || DEFAULT_ERR) : NET_ERR);
  }

  /* Requests the page made before this script ran (rk-cart-early recorded them): replay their results now. */
  if (EARLY) {
    EARLY.handler = function (it) {
      var isAdd = it.kind === 'add';
      outcome(isAdd, it.url.indexOf('opens_cart=never') > -1, wantsJs(it.init) && formHasErrorBox(it.init),
        isAdd ? requestedQtys(it.init) : null, it.ok, it.status, it.json, it.btn);
    };
    EARLY.q.splice(0).forEach(EARLY.handler);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || e.defaultPrevented) return;
    var path;
    try { path = new URL(f.getAttribute('action') || '', location.href).pathname; } catch (err) { return; }
    if (!/\/cart\/add\/?$/i.test(path) || root.contains(f)) return;
    e.preventDefault();
    var src = srcNow();
    var fd = new FormData(f);
    api('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (j) { emitFromResponse(j, '', [parseInt(fd.get('quantity'), 10) || 1], src); return openAfterAdd(); })
      .catch(function (e) { showError(e.rkMessage || DEFAULT_ERR); });
  });

  /* Sold-out variants: the hero's color/size picker (rk-pdp:variant) disables the page-product add buttons
     (and relabels them "Sold out"); picking an available variant restores them. */
  function setAvailable(btn, av) {
    var lab = btn.querySelector('[class*="__label"]') || btn.querySelector('span:not([class*="icon"]):not([class*="arrow"]):not([class*="bag"])') || btn;
    if (!btn.hasAttribute('data-rk-label')) btn.setAttribute('data-rk-label', lab.textContent.trim());
    btn.disabled = !av;
    if (av) { btn.removeAttribute('aria-disabled'); btn.removeAttribute('data-rk-soldout'); }
    else { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('data-rk-soldout', ''); }
    lab.textContent = av ? btn.getAttribute('data-rk-label') : 'Sold out';
  }
  document.addEventListener('rk-pdp:variant', function (e) {
    var d = e.detail || {};
    var av = d.available !== false;
    [].forEach.call(document.querySelectorAll(
      '[data-rk-atc], rk-ltb-atc [data-rk-variant-input] ~ button[type="submit"], rk-lw-atc[data-page-product] button[type="submit"], rk-lmb-atc[data-product="' + d.product + '"] button[type="submit"]'
    ), function (b) { setAvailable(b, av); });
  });

  document.addEventListener('upcart:open', function () { openAfterAdd(); });
  document.addEventListener('upcart:refresh', function () { refresh().catch(function () {}); });
  document.addEventListener('cart:refresh', function () { refresh().catch(function () {}); });

  /* Stock Refresh <cart-drawer> still reacts to product-form adds; stop it from opening / locking scroll. */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (C && C.prototype) { C.prototype.open = function () {}; C.prototype.close = function () {}; }
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-rk-atc], [data-rk-atc-id], button[type="submit"]');
    if (b) { lastAtc = { id: window.__rkAtcSource || b.getAttribute('data-rk-atc-id') || b.id || '', t: Date.now() }; window.__rkAtcSource = ''; }
  }, true);

  tagAtcButtons();
  window.addEventListener('load', tagAtcButtons);

  window.RkCart = { open: openAndRefresh, close: close, refresh: refresh, error: showError, money: money };

  /* A /cart click that happened before this deferred script ran was held by rk-cart-early: take over and open now. */
  if (window.__rkCartEarly) {
    var early = window.__rkCartEarly;
    if (early.off) early.off();
    if (early.pending) { early.pending = false; openAndRefresh(); }
    /* form adds held by the stub: replay them now that every page script has registered its submit handler */
    if (early.forms && early.forms.length) {
      setTimeout(function () {
        early.forms.splice(0).forEach(function (f) { try { f.requestSubmit(); } catch (err) { f.submit(); } });
      }, 0);
    }
  }
  window.upcartOpenCart = openAndRefresh;
  window.upcartRefreshCart = refresh;
  window.UpCart = window.UpCart || window.RkCart;

  if (!isOpen) root.setAttribute('inert', '');

  /* Warm the drawer so the first open is instant (cart + product data fetched while the page is idle). */
  function warm() {
    if (cart || inflight) return;
    api('/cart.js').then(function (c) { if (!cart) { cart = c; painted = false; updateBubble(c.item_count); } }).catch(function () {});
  }
  /* back/forward cache: the restored page can hold an old cart */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    cart = null; painted = false;
    if (isOpen) refresh().catch(function () {}); else warm();
  });
  if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 3000 });
  else setTimeout(warm, 1500);
})();
